<template>
  <div class="page-topic">
    <div class="left topic-left-items">
      <router-link
        :to="{
          name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
          query:
            item.cate_type == 2
              ? {
                  id: item.cate_id,
                  cate_type: item.cate_type,
                  name: item.name,
                }
              : {
                  id: item.cate_id,
                  cate_type: item.cate_type,
                  name: item.name,
                },
        }"
        class="topic-left-item"
        v-for="item in categoryList"
        :key="item.cate_id"
      >
        <!-- pid: item.pid, -->
        <!-- cate_type 栏目类型：1=文章列表页（请求列表页接口），2=目录，意思是包含下级栏目（请求栏目列表接口） -->
        <img :src="item.image | baseImg" class="img" />
        <div class="tit z-line-1">{{ item.name }}</div>
      </router-link>
    </div>
    <div class="right">
      <div class="topic-title">实时动态</div>
      <div class="topic-items">
        <router-link
          :to="{
            name: 'topic_detail',
            query: {
              id: item.id,
            },
          }"
          class="topic-item z-line-1"
          v-for="item in list.slice(0, 5)"
          :key="item.id"
          :title="item.title"
        >
          {{ item.title }}
        </router-link>
      </div>
      <div class="topic-items" v-if="list.length > 5">
        <router-link
          :to="{
            name: 'topic_detail',
            query: {
              id: item.id,
            },
          }"
          class="topic-item z-line-1"
          v-for="item in list.slice(5)"
          :key="item.id"
          :title="item.title"
        >
          {{ item.title }}
        </router-link>
      </div>
      <div class="z-pagination" v-if="total">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size.sync="per_page"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <span class="z-pagination__total"> 共 {{ total }} 条 </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryZhuanti, getIndexZhuanti } from "../../apis/topic";

export default {
  data() {
    return {
      categoryList: [],
      //
      per_page: 10,
      current_page: 1,
      total: 0,
      list: [],
    };
  },
  created() {
    this.getCategoryZhuanti();
    this.getIndexZhuanti();
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit("currentChange", page);
      this.getIndexZhuanti();
    },
    async getIndexZhuanti() {
      const { data } = await getIndexZhuanti({
        page: this.current_page,
        pagenum: this.per_page,
      });
      this.total = data.total;
      this.per_page = data.per_page;
      this.current_page = data.current_page;
      this.list = data.data;
    },
    async getCategoryZhuanti() {
      console.log(111);
      console.log('');
      const { data } = await getCategoryZhuanti();
      this.categoryList = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-topic {
  display: flex;
  .left {
    flex: 1;
    flex-shrink: 0;
  }
  .right {
    width: 443px;
    height: 640px;
    background: rgba(245, 245, 245, 0.39);
    padding: 0 20px;
    .topic-title {
      // height: 25px;
      font-size: 18px;
      font-size: var(--font-size-18);
      font-weight: bold;
      line-height: 25px;
      color: #303133;
      border-bottom: 1px solid #dcdfe6;
      width: 403px;
      padding: 16px 0;
    }
  }
}

.topic-left-items {
  font-size: 0;
  .topic-left-item {
    display: inline-block;
    margin-bottom: 20px;
    margin-right: 17px;
    font-size: 0;
    .img {
      // width: 440px;
      // height: 262px;
      // width: 364px;
      // height: 122px;
      width: 440px;
      height: 148px;
      object-fit: cover;
    }
    .video{
      width: 440px;
      height: 148px;
      object-fit: cover;
    }
    .tit {
      font-size: 20px;
      font-size: var(--font-size-20);
      text-align: center;
      font-weight: 500;
      line-height: 28px;
      color: #303133;
      margin-top: 20px;
    }
  }
}

.topic-items {
  margin-top: 22px;
  border-bottom: 1px solid #dcdfe6;
  .topic-item {
    height: 22px;
    font-size: 16px;
    font-size: var(--font-size-16);
    font-weight: 500;
    line-height: 22px;
    margin-bottom: 20px;
    color: #303133;
    display: block;
    &:hover {
      color: #0d7ce4;
    }
  }
}
</style>
